export const dict = {
  en: {
    "app.name": "AcademiaOS",
    "app.tagline": "Unified Academic Intelligence Platform",
    "nav.dashboard": "Dashboard",
    "nav.institution_setup": "Institution Setup",
    "nav.academic_structure": "Academic Structure",
    "nav.users_roles": "Users & Roles",
    "nav.ai_use_cases": "AI Use Cases",
    "nav.content_studio": "Content Studio",
    "nav.ai_instructor": "AI Instructor",
    "nav.ai_advisor": "AI Advisor",
    "nav.student_assistant": "Student Assistant",
    "nav.assessments": "Assessments",
    "nav.psychometrics": "Psychometrics",
    "nav.analytics": "Analytics",
    "nav.workflows": "Agentic Workflows",
    "nav.compliance": "Compliance & Audit",
    "nav.settings": "Settings",
    "topbar.search": "Search programmes, courses, learners…",
    "topbar.ai_status": "AI · Compliant",
    "topbar.logout": "Log out",
    "login.title": "Sign in to AcademiaOS",
    "login.subtitle": "The Operating System for the AI-Native University",
    "login.email": "Work email",
    "login.password": "Password",
    "login.submit": "Continue",
    "login.demo_accounts": "Demo accounts",
    "dashboard.eyebrow": "Control Room",
    "common.programmes": "Programmes",
    "common.courses": "Courses",
    "common.learners": "Learners",
    "common.faculty": "Faculty",
    "common.add": "Add",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.next": "Next",
    "common.back": "Back",
    "common.finish": "Finish",
    "common.view_all": "View all",
    "common.coming_soon": "This module ships in the next build phase.",
  },
  ar: {
    "app.name": "أكاديميا أو إس",
    "app.tagline": "منصة الذكاء الأكاديمي الموحدة",
    "nav.dashboard": "لوحة التحكم",
    "nav.institution_setup": "إعداد المؤسسة",
    "nav.academic_structure": "الهيكل الأكاديمي",
    "nav.users_roles": "المستخدمون والأدوار",
    "nav.ai_use_cases": "حالات استخدام الذكاء الاصطناعي",
    "nav.content_studio": "استوديو المحتوى",
    "nav.ai_instructor": "المدرس الذكي",
    "nav.ai_advisor": "المستشار الذكي",
    "nav.student_assistant": "مساعد الطالب",
    "nav.assessments": "التقييمات",
    "nav.psychometrics": "القياسات النفسية",
    "nav.analytics": "التحليلات",
    "nav.workflows": "سير العمل الوكيل",
    "nav.compliance": "الامتثال والتدقيق",
    "nav.settings": "الإعدادات",
    "topbar.search": "ابحث عن البرامج والدورات والمتعلمين…",
    "topbar.ai_status": "الذكاء الاصطناعي · متوافق",
    "topbar.logout": "تسجيل الخروج",
    "login.title": "تسجيل الدخول إلى أكاديميا أو إس",
    "login.subtitle": "منظومة التشغيل للجامعة الذكية",
    "login.email": "البريد المهني",
    "login.password": "كلمة المرور",
    "login.submit": "متابعة",
    "login.demo_accounts": "حسابات تجريبية",
    "dashboard.eyebrow": "غرفة التحكم",
    "common.programmes": "البرامج",
    "common.courses": "الدورات",
    "common.learners": "المتعلمون",
    "common.faculty": "أعضاء هيئة التدريس",
    "common.add": "إضافة",
    "common.save": "حفظ",
    "common.cancel": "إلغاء",
    "common.next": "التالي",
    "common.back": "السابق",
    "common.finish": "إنهاء",
    "common.view_all": "عرض الكل",
    "common.coming_soon": "ستتوفر هذه الوحدة في المرحلة التالية.",
  },
};

export function t(lang, key) {
  return (dict[lang] && dict[lang][key]) || dict.en[key] || key;
}
